/*
 * @Author: Finget
 * @Date: 2020-04-24 10:50:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-01 15:49:54
 * @FilePath: /sdk/find_password/src/util/request.js
 */
import Vue from 'vue';
import axios from 'axios';
import router from '@/router';
import { Toast } from 'vant';
import storage from '@/utils/storage';
import eventBus from '@/utils/eventBus';

// const location = window.location;

// console.log('location', location);

// import qs from 'qs';
const service = axios.create({
  // api base_url
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: 改为根据域名来作为接口请求地址
  // baseURL: location.origin,
  // 请求超时时间，
  timeout: 10000,
  withCredentials: true
});
service.interceptors.request.use(config => {

  if (storage.getItem('token')) {
    config.headers['Authorization'] = storage.getItem('token');
  }
  config.headers['Accept-Language'] = storage.getItem('lang') || 'zh';

  return config;
});

service.interceptors.response.use((response) => {
  const config = response.config || '';
  const res = response.data;
  if (res.code === 0 || res.code === 10) {
    if (config && config.successNotice) {
      Toast.success(res.msg);
    }
    return res;
  } else {
    if (res.code === 401) {
      storage.removeItem('token');
      // router.replace({
      //   name: 'Login',
      //   query: {
      //     redirect: router.currentRoute.fullPath
      //   }
      // });
      eventBus.$emit('showLogin');
      if (config && config.errNotice) {
        Toast.fail(res.msg);
      }
    } else if (res.code === 403) {
      router.replace({
        name: 'SelectGame'
      });
    } else {
      if (config && config.errNotice) {
        Toast.fail(res.msg);
      }
    }
    
    return res;
  }
});

// const productId = Vue.prototype.$obj.productId;

function get(url, params = {},errNotice = true, successNotice=false) {
  return new Promise((resolve, reject) => {
    const game_id = storage.getGameId();
    service({
      url: url,
      method: 'get',
      params: Object.assign({
        game_id: (game_id && Number(game_id) && Number(game_id) !== 0) ? Number(game_id) : null,
        lang: storage.getItem('lang')
      }, params || {}),
      errNotice,
      successNotice
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
function post(url, params = {},errNotice = true, successNotice=false) {
  return new Promise((resolve, reject) => {
    const game_id = storage.getGameId();
    service({
      url: url,
      method: 'post',
      data: Object.assign({
        game_id: (game_id && Number(game_id) && Number(game_id) !== 0) ? Number(game_id) : null,
        lang: storage.getItem('lang')
      }, params),
      errNotice,
      successNotice
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}


Vue.prototype.$http = service;

export default {
  get, post
};